import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table } from 'react-bootstrap';

import PropTypes from 'prop-types';

import { faMobileAlt, faGlobe } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";



class QuoteListView extends React.Component {
	
	constructor(props) {
		super(props);
		
		this.app = this.props.app;
		this.getMvcModuleObject = this.app.getMvcModuleObject;
		this.getMvcMyQuoteObject = this.app.getMvcMyQuoteObject;

		this.uuid = this.app.guid();

		this.closing = false;
		
		this.state = {
			items: []
		}
	}

	_setState(state) {
		if (this.closing !== true)
		this.setState(state);
	}
	
	// post render commit phase
	componentDidMount() {
		console.log('QuoteListView.componentDidMount called');

		let mvcmodule = this.getMvcModuleObject();
		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;
		
		mvcmodule.registerEventListener('on_refreshPage', this.uuid, this.onRefreshPage.bind(this));
		
		mvcmyquote.readQuotes(rootsessionuuid, walletuuid)
		.then((quotes) => {
			for (var i = 0; i < (quotes ? quotes.length : 0); i++) {
				quotes[i].uuid = quotes[i].txhash;
				quotes[i].time = quotes[i].savetime/1000;
				quotes[i].formattedtime = mvcmodule.formatDate(quotes[i].time, 'YYYY-mm-dd HH:MM:SS');
			}

			// sort descending order
			if (quotes)
			quotes.sort(function(a,b) {return ((b.time !== undefined ? b.time : 0) - (a.time !== undefined ? a.time : 0));});

			this._setState({items: quotes});
		})
		.catch(err => {
			console.log('error in QuoteListView.componentDidMount: ' + err);
		});
	}
	
	async onRefreshPage() {
		console.log('QuoteListView.onRefreshPage called');
	}
	
	// end of life
	componentWillUnmount() {
		console.log('QuoteListView.componentWillUnmount called');

		let app = this.app;
		let mvcmodule = app.getMvcModuleObject();
		
		this.closing = true;

		mvcmodule.unregisterEventListener('on_refreshPage', this.uuid);
	}

	
	// user actions
	async onClickItem(item) {
		let txhash = item.txhash;
		let currencyuuid = item.currencyuuid;

		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;

		let stop = false;
		let quote = await mvcmyquote.fetchCurrencyTransaction(rootsessionuuid, walletuuid, currencyuuid, txhash)
		.catch(err => {
			console.log('error in QuoteListView.onClickItem ' + err);

			if (err == 'ERR_MISSING_CREDENTIALS') {
				this.app.alert('No sufficient rights to perform action.')
				stop = true;
			}
		});

		if (stop === true)
			return;

		if (!quote) {
			this.app.alert('Could not find quote. Quotes may take a few seconds before being fully registered.')
			return;
		}

		let params = {action: 'view', txhash, currencyuuid, dataobject: quote};

		this.app.gotoRoute('quote', params);
	}

	renderItem(item){
		let mvcmodule = this.app.getMvcModuleObject();

		let title = mvcmodule.fitString(item.title, 21);
		let formattedtime = item.formattedtime;
		let uuid= item.txhash;

		return (
			<tr key={uuid} onClick={() => this.onClickItem(item)}>
				<th>{formattedtime}</th>
				<th>{title}</th>
			</tr>
		);
	}
	
	renderList() {
		let {items} = this.state;

		return (
			<Table responsive>
				<thead className="ListHeader">
					<tr>
					<th>Time</th>
					<th>Title</th>
					</tr>
				</thead>
				<tbody className="ListItem" >
				{items.map((item, index) => {
					return (this.renderItem(item));
				})}
				</tbody>
			</Table>
		);	
	}
	
	
	// rendering
	render() {
		let {items} = this.state;
		
		return (
			<div className="Container">
				<div className="Title">List of quotes</div>
				{this.renderList()}
			</div>
		);
	}
	
}


// propTypes validation
QuoteListView.propTypes = {
	app: PropTypes.object.isRequired,
	rootsessionuuid: PropTypes.string,
};

//redux
const mapStateToProps = (state) => {
	return {
		rootsessionuuid: state.session.sessionuuid,
		pending: state.login.pending,
		success: state.login.success,
		lasterror: state.login.error,
		currentwalletuuid: state.wallets.walletuuid,
	};
}

const mapDispatchToProps = (dispatch) => {
	return {
	};
}


export {QuoteListView};
export default connect(mapStateToProps, mapDispatchToProps)(QuoteListView);

